export const routes = {
  landing: '/',
  registration: '/registrieren',
  login: '/anmelden',
  resetPassword: '/passwort',
  dashboard: '/dashboard',
  chat: '/dashboard/chat',
  appointments: '/dashboard/termine',
  ownCustomForms: '/dashboard/formulare',
  appointmentBooking: '/dashboard/termine/buchen',
  profile: '/dashboard/profil',
  myArea: '/dashboard/mein-bereich',
  fileStorage: '/dashboard/dateiablage',
  proofOfSalary: '/dashboard/gehaltsnachweise',
  news: '/dashboard/mein-bereich/news',
  unreadNews: '/dashboard/mein-bereich/news/ungelesen',
  impressum: '/impressum',
  datenschutz: '/datenschutz',
  unreadAppointments: '/dashboard/termine/ungelesen',
  unreadInformation: '/dashboard/mein-bereich/ungelesen',
  appointmentBookingCategory: (id?: string, specId?: string) =>
    `/dashboard/termine/buchen/${id ?? 'ohneKategorie'}${specId ? `?specialization=${specId}` : ''}`,

  information: (id: string) => `/dashboard/information/${id}`,
  publicInformation: (id: string) => `/information/${id}`,
  appointment: (id: string) => `/dashboard/termine?termin=${id}`,
  video: (id: string) => `dashboard/video/${id}`,
  myAreaInformationCategory: (categoryId: string) =>
    `/dashboard/mein-bereich/${categoryId}`,
};
